import { render, staticRenderFns } from "./template-note.vue?vue&type=template&id=757f6c10"
import script from "./template-note.vue?vue&type=script&lang=js"
export * from "./template-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports